import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Context } from "../../store/AppContext";
import Head from "../Head";
import QuotePreview from "./QuotePreview";
import CotizacionStatusBadge from "./CotizacionStatusBadge";
import { quoteRepository } from "../../Helper/Cotizacion/quoteRepository";
import { downloadQuotePdf, openQuotePdf } from "../../Helper/Cotizacion/quotePdf";
import { formatCLP } from "../../Helper/Cotizacion/currencyUtils";

const CotizacionDetailPage = () => {
	const { store } = useContext(Context);
	const navigate = useNavigate();
	const { id } = useParams();
	const [quote, setQuote] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState("");

	useEffect(() => {
		if (store.usuarioActual == null && store.token == null) {
			const timer = setTimeout(() => navigate("/"), 200);
			return () => clearTimeout(timer);
		}
		return undefined;
	}, [store.usuarioActual, store.token, navigate]);

	useEffect(() => {
		let active = true;
		const load = async () => {
			setLoading(true);
			const data = await quoteRepository.getById(id);
			if (!active) return;
			if (!data) {
				setError("Cotización no encontrada.");
				setQuote(null);
			} else {
				setQuote(data);
			}
			setLoading(false);
		};
		load();
		return () => {
			active = false;
		};
	}, [id]);

	if (loading) {
		return (
			<div className="no-print">
				<Head contenido={["Detalle de cotización", ""]} />
				<div className="grid-container fluid" style={{ padding: "16px" }}>
					<p>Cargando...</p>
				</div>
			</div>
		);
	}

	if (error || !quote) {
		return (
			<div className="no-print">
				<Head contenido={["Detalle de cotización", ""]} />
				<div className="grid-container fluid" style={{ padding: "16px" }}>
					<p>{error || "No encontrada"}</p>
					<Link to="/cotizacion" className="button hollow">
						Volver al listado
					</Link>
				</div>
			</div>
		);
	}

	return (
		<div className="no-print">
			<Head contenido={["Detalle de cotización", quote.number || "Borrador"]} />
			<div className="grid-container fluid" style={{ padding: "0 16px 40px" }}>
				<div
					style={{
						display: "flex",
						justifyContent: "space-between",
						alignItems: "center",
						flexWrap: "wrap",
						gap: "10px",
						marginBottom: "16px",
					}}
				>
					<div>
						<h3 style={{ marginBottom: "4px" }}>
							{quote.number || "Borrador sin número"}
						</h3>
						<div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
							<CotizacionStatusBadge status={quote.status} />
							<span style={{ color: "#4a5568" }}>{formatCLP(quote.grandTotal || 0)}</span>
						</div>
					</div>
					<div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
						<Link to="/cotizacion" className="button hollow secondary" style={{ marginBottom: 0 }}>
							Volver al listado
						</Link>
						{quote.status === "borrador" ? (
							<Link
								to={`/cotizacion/editar/${quote.id}`}
								className="button secondary"
								style={{ marginBottom: 0 }}
							>
								Editar
							</Link>
						) : null}
						<button
							type="button"
							className="button hollow"
							style={{ marginBottom: 0 }}
							onClick={() => openQuotePdf(quote)}
						>
							Abrir PDF
						</button>
						<button
							type="button"
							className="button primary"
							style={{ marginBottom: 0 }}
							onClick={() => downloadQuotePdf(quote)}
						>
							Descargar PDF
						</button>
					</div>
				</div>

				<section style={{ marginBottom: "16px" }}>
					<h5>Vista previa visual</h5>
					<QuotePreview quote={quote} />
				</section>
			</div>
		</div>
	);
};

export default CotizacionDetailPage;
